import './App.css';
import Header from './layouts/header/header';
import Footer from './layouts/footer/footer';
import { routesConfig } from "./routers/routersConfig";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from './middleware/protectedRoute';
import { useEffect, useState } from 'react';
import useUrlChange from './hooks/useUrlChange';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Store from './services/store';
import { RecoilRoot } from "recoil";
// import { messaging, getToken, onMessage, getMessaging } from "./config/firebaseConfig";

function App() {
  const [isHeader, setIsHeader] = useState(false);
  // const [notification, setNotification] = useState(null);
  // const vapidKey = 'BDEh-AP9gUACx7gjmL4lO8rmbB-uGSmwfKAcUcioGxvIJ8sOOccApbCq5KLA979v8Sjdst6txBG0JjP0q7Yg630';
  useUrlChange((path) => {
    setIsHeader(path !== '/login' && path !== '/personalDetails' && path !== '/questionnaire' && path !== '/self-serive-form' && path !== '/practice-registration-under-review');
  });

  useEffect(() => {
    // const requestPermission = async () => {
    //   try {
    //     const permission = await Notification.requestPermission();
    //     if (permission === "granted") {
    //       const token = await getToken(messaging, {
    //         vapidKey: vapidKey, // Replace with your Firebase VAPID Key
    //       });
    //       console.log("FCM Token:", token);

    //       // ✅ Attach `onMessage` here after permission is granted
    //       messaging.onMessageHandler((payload) => {
    //         console.log("📩 Foreground Message received:", payload);
    //         setNotification(payload.notification);
    //       });
    //     } else {
    //       console.warn("User denied notification permission.");
    //     }
    //   } catch (error) {
    //     console.error("Error requesting notification permission:", error);
    //   }
    //   // }
    // };

    // requestPermission();
    // const messaging = getMessaging();
    // onMessage(messaging, (payload) => {
    //   console.log("Message received: ", payload);

    //   // // Define a static notification
    //   const staticTitle = "Static Notification Title";
    //   const staticBody = {
    //     body: "This is a static notification message.",
    //     icon: "/static-icon.png", // Optional: Change to your preferred icon path
    //     badge: "/badge-icon.png", // Optional: Badge icon for the notification
      
    //   };
    //   console.log("📩 Foreground Message received:", payload);

    //   // Extract notification data
    //   const { title, body } = payload.notification || {};

    //   // Display notification using the browser Notification API
    //   if (Notification.permission === "granted") {
    //     payload.notification ? new Notification(title,  body) : new Notification(staticTitle,  staticBody);
    //   } else {
    //     console.log("Notification permission not granted.");
    //   }
    // });

  }, []);


  return (
    <div className="App">
      <ToastContainer />
      <RecoilRoot>
        <BrowserRouter>
          <Store>
            {isHeader && <Header />}
            <Routes>
              {routesConfig.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    route.requiredAuthentication ? (
                      <ProtectedRoute
                        requiredAuthentication={route.requiredAuthentication}
                        requiredPermissions={route.requiredPermissions}
                      >
                        {route.element}
                      </ProtectedRoute>
                    ) : (
                      route.element
                    )
                  }
                />
              ))}
            </Routes>
          </Store>
        </BrowserRouter>
      </RecoilRoot>
      <Footer />
    </div>
  );
}

export default App;